import { message, Select } from "antd";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallV2 } from "hooks";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { DropdownSuffix, SearchIcon } from "icons";
import styles from "./styles.module.scss";
import { useCurrentUserContext } from "providers";
import { useState } from "react";

export const UpdateCaseUser = ({ refetchCases, employees, caseId, value }) => {
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();
  const [userNameLocal, setuserNameLocal] = useState(value);

  const [
    updateCaseUser,
    {
      data: updateCaseUserData,
      isLoading: updateCaseUserLoading,
      error: updateCaseUserErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_case_user",
    method: "POST",
  });

  async function handleSelect(value, data, case_id) {
    setuserNameLocal(value);
    try {
      const res = await updateCaseUser({
        params: { case_id, newUser: value, loggedUser: user?.email },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        refetchCases();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <div className={styles.statusUpdate}>
      <div className={`${styles.dropdown}`}>
        <Select
          dropdownStyle={{ minWidth: "250px" }}
          value={userNameLocal}
          defaultValue={value}
          showSearch
          filterOption={(
            input,
            option, // 👈 filter logic
          ) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          style={{
            // width: "180px",
            height: "4.3dvh",
            overflow: "hidden",
          }}
          placeholder={translator("Search")}
          onChange={(value, data) => handleSelect(value, data, caseId)}
          options={employees}
          suffixIcon={<DropdownSuffix height={12} width={12} />}
        />
      </div>
    </div>
  );
};
